import { PublicKey } from "@solana/web3.js";

export const MAX_RECEIVERS = 8;
export const RECEIVERS_FLAG = 0x80;

/** sha256("account:LockReceivers").slice(0, 8) */
export const LOCK_RECEIVERS_DISC = Buffer.from([
  38, 49, 104, 18, 170, 179, 123, 197,
]);

export function deriveLockReceiversPda(programId, lockRecordPda) {
  const program =
    programId instanceof PublicKey ? programId : new PublicKey(programId);
  const lockRecord =
    lockRecordPda instanceof PublicKey
      ? lockRecordPda
      : new PublicKey(lockRecordPda);
  const [pda, bump] = PublicKey.findProgramAddressSync(
    [Buffer.from("lock_receivers"), lockRecord.toBuffer()],
    program,
  );
  return { pda, bump };
}

function readU64LE(buf, offset) {
  const lo = buf.readUInt32LE(offset);
  const hi = buf.readUInt32LE(offset + 4);
  return BigInt(lo) + (BigInt(hi) << 32n);
}

/**
 * Layout: disc(8) + lock_record(32) + original_amount(8) + bump(1) + count(1)
 * + wallets[8](256) + claimed[8](64)
 */
export function decodeLockReceivers(data, pda) {
  const buf = Buffer.from(data || []);
  if (buf.length < 8 + 32 + 8 + 1 + 1 + 256 + 64) return null;
  if (!buf.subarray(0, 8).equals(LOCK_RECEIVERS_DISC)) return null;
  const lockRecord = new PublicKey(buf.subarray(8, 40)).toBase58();
  const originalAmount = readU64LE(buf, 40).toString();
  const bump = buf[48];
  const count = buf[49];
  const wallets = [];
  const claimed = [];
  for (let i = 0; i < 8; i += 1) {
    wallets.push(new PublicKey(buf.subarray(50 + i * 32, 82 + i * 32)).toBase58());
    claimed.push(readU64LE(buf, 50 + 256 + i * 8).toString());
  }
  return {
    pda: typeof pda === "string" ? pda : pda.toBase58(),
    lockRecord,
    originalAmount,
    bump,
    count,
    wallets: wallets.slice(0, count),
    claimed: claimed.slice(0, count),
  };
}

export function receiverShareRaw(totalStr, count, index) {
  const total = BigInt(totalStr || "0");
  const n = BigInt(count || 0);
  if (n <= 0n) return 0n;
  const base = total / n;
  const rem = total % n;
  if (index + 1 === Number(n)) return base + rem;
  return base;
}

export function parseReceiverWallets(rawList) {
  const seen = new Set();
  const out = [];
  for (const raw of rawList || []) {
    const s = String(raw || "").trim();
    if (!s) continue;
    let pk;
    try {
      pk = new PublicKey(s);
    } catch {
      throw new Error(`Invalid receiver wallet: ${s}`);
    }
    const b58 = pk.toBase58();
    if (seen.has(b58)) continue;
    seen.add(b58);
    out.push(pk);
  }
  if (out.length > MAX_RECEIVERS) {
    throw new Error(`At most ${MAX_RECEIVERS} receiver wallets.`);
  }
  return out;
}
